import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

// footerBg
// footerColor

export const tableThemeTokens: any = {
  algorithm: true,
  headerBorderRadius: 0,
  bodySortBg: "transparent",
  footerBg: variableColors["ColorFigmaComplementaryBlue05"],
  footerColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  headerColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  borderColor: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  headerBg: variableColors["ColorFigmaNeutralGrayscaleGray20"],
  headerSortHoverBg: variableColors["ColorFigmaNeutralGrayscaleGray20"],
  formSplitColor: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  rowHoverBg: variableColors["ColorFigmaNeutralGrayscaleGray10"],
  rowSelectedBg: variableColors["ColorFigmaComplementaryBlue10"],
  rowSelectedHoverBg: variableColors["ColorFigmaNeutralGrayscaleGray10"],
  stickyScrollBarBg: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorBgContainer: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorBgSpin: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorLink: variableColors["ColorFigmaComplementaryBlue50"],
  colorLinkActive: variableColors["ColorFigmaComplementaryBlue50"],
  colorLinkHover: variableColors["ColorFigmaComplementaryBlue50"],

  colorPrimary: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorPrimaryBorder: variableColors["ColorFigmaComplementaryBlue50"],

  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  controlItemBgHover: "transparent",
  controlItemBgActive: variableColors["ColorFigmaNeutralGrayscaleGray70"],

  boxShadowSecondary: variableEffects["BoxShadowElevation3"],

  fontSize: variableTypography["BodyMediumFontSize"],
  fontSizeIcon: variableTypography["BodyMediumFontSize"],
  fontFamily: variableTypography["BodyMediumFontFamily"],
  fontWeightStrong: variableTypography["BodyH300FontWeight"],

  fontSizeSM: variableTypography["BodyMediumFontSize"],

  cellFontSize: variableTypography["BodyLargeFontSize"],
  cellFontSizeMD: variableTypography["BodyMediumFontSize"],
  cellFontSizeSM: variableTypography["BodySmallFontSize"],

  expandColorIcon: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  expandSizeIcon: 16,

  cellPaddingBlock: "16px 8px",
  cellPaddingBlockMD: "10px 8px",
  cellPaddingBlockSM: "6px 8px",
};
